import { connect } from 'react-redux';
import { getUserWithId } from 'selectors/user';
import IncompleteReportCard from './IncompleteReportCard';

export default connect((state, props) => ({
  student: getUserWithId(props.lesson.clientId)(state).toJS(),
}))(IncompleteReportCard);
